export default __webpack_public_path__ + "static/media/screenshot.59d1fd60.svg";